
function calcMenuH(){

  let menuh = document.querySelector("#menuBlock");
  let announcement = document.querySelector(".announcement-bar");
  height = 0;
  if(menuh != null){
    height += menuh.offsetHeight;
  }
  return height;
}

function calcAnnouncement(){
  let announcementBar = document.querySelector(".announcement-bar");
  if(announcementBar != null){
    announcementBar = document.querySelector(".announcement-bar").offsetHeight;
  }
  else{
    announcementBar = 0;
  }
  return announcementBar;
}

let vh, menuh;
let send = false;

function viewportSizing(){
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  let size, sizeA;
  size = calcMenuH();
  sizeA = calcAnnouncement();
  document.documentElement.style.setProperty('--menuOnly', size+"px");
  document.documentElement.style.setProperty('--announcementBar', sizeA+"px");
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}


window.addEventListener("resize", function(){
  viewportSizing();
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--menuh', calcMenuH()+"px");
  document.documentElement.style.setProperty('--announcementBar', calcAnnouncement()+"px");
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

document.addEventListener("DOMContentLoaded", e=>{
  viewportSizing();
  document.querySelectorAll(".scrollDown").forEach(function(scroll){
    scroll.addEventListener("click", e=>{
      let pageHeight = window.innerHeight - document.getElementById("menuBlock").offsetHeight - window.pageYOffset;
      window.scrollBy({top: pageHeight, behavior : "smooth"});
    })
  })
});